import {Glide, Controls, Swipe, Autoplay, Images, Keyboard } from './carousel'

(function () {
    const carouselElements = document.getElementsByClassName('js-slot-mbb-carousel');

    const Fadeout = function(_,Components,Events) {
        Events.on('run.before', function() {
            $(Components.Html.slides[_.index]).addClass('fadeout');
        });
        Events.on('run.after', function() {
            $(Components.Html.root).find('.fadeout').removeClass('fadeout')
        });
        return {};
    };

    Array.from(carouselElements).forEach(carousel => {
        const autoPlay = 5000;
        const $slides = $(carousel).find('.glide__slide');
        if ($slides.length <= 1) {
            return;
        }
        new Glide(carousel, {
            type: 'carousel',
            gap: 0,
            hoverpause: false,
            autoplay: autoPlay,
            animationDuration: 1500,
            animationTimingFunc: 'ease-in-out'
        }).mount({
            Controls,
            Swipe,
            Autoplay,
            Images,
            Keyboard,
            'Fadeout': Fadeout
        });
    });
})();